import { render } from "./AssignRoleDataTable.vue?vue&type=template&id=93bfbeaa&scoped=true"
import script from "./AssignRoleDataTable.vue?vue&type=script&lang=js"
export * from "./AssignRoleDataTable.vue?vue&type=script&lang=js"

import "./AssignRoleDataTable.vue?vue&type=style&index=0&id=93bfbeaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93bfbeaa"]])

export default __exports__